import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["title", "cover", "submit"];

  connect() {
  }

  showSubmit() {
    this.submitTarget.classList.remove("invisible");
  }
}
